// Statuses that mean work was dropped rather than finished. Mirrors the API's default in
// Waypointr.Reports.RemovedStatuses.
export const DEFAULT_REMOVED_STATUSES = ['Removed'];

export function configuredRemovedStatuses(configuration) {
  return configuration?.removed_statuses ?? DEFAULT_REMOVED_STATUSES;
}

export function parseRemovedStatuses(text) {
  return (text || '')
    .split(',')
    .map((status) => status.trim())
    .filter(Boolean);
}

export function formatRemovedStatuses(statuses) {
  return (statuses || []).join(', ');
}
